import { render, staticRenderFns } from "./_recommend.vue?vue&type=template&id=5ea0a62c&scoped=true&"
import script from "./_recommend.vue?vue&type=script&lang=js&"
export * from "./_recommend.vue?vue&type=script&lang=js&"
import style0 from "./_recommend.vue?vue&type=style&index=0&id=5ea0a62c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea0a62c",
  null
  
)

export default component.exports